let showMessage = (counter, saving) => {
  if (saving) return null

  return <span className="count-down-message">Next save in {counter} seconds</span>
}

const CountDownMessage = ({ counter, saving }) => {
  return (
    <div style={{ display: 'flex' }}>
      <div>{showMessage(counter, saving)}</div>
    </div>
  )
}

CountDownMessage.defaultProps = { counter: 30, saving: false }
export default CountDownMessage
